export default __webpack_public_path__ + "static/media/fox.391203d6.jpg";